import gql from "graphql-tag";
import { useApolloGqlMutation } from "frontend/hooks/useApolloGql/useApolloGqlMutation.js";
import { messaging } from "frontend/components/fort/mod/photos/constants.js";

// GQL
// If Moderator update photo title, they are also approving it
const UPDATE_AND_APPROVE_PHOTO_UPLOAD_TITLE = gql`
    mutation upadateAndApprovePhotoUploadTitle(
        $photoUploadId: ID!
        $value: String
    ) {
        setPhotoUploadTitle(photoUploadId: $photoUploadId, value: $value) {
            errors
            ok
            photoUpload {
                photoTitle
            }
        }
        approvePhotoUploadTitle(photoUploadId: $photoUploadId) {
            errors
            ok
            photoUpload {
                photoTitleApproved
                photoTitle
            }
        }
    }
`;

const errorHandler = normalizedResp => {
    const { message, errors } = normalizedResp;
    let newMessage = message;

    if (errors.includes("Submitted value contains disallowed terms")) {
        newMessage = messaging.errors.containsDisallowedTerms("title");
    }

    return {
        ...normalizedResp,
        message: newMessage
    };
};

export const useUpdateAndApprovePhotoUploadTitle = () => {
    return useApolloGqlMutation({
        actionDesc: "Update and Approve Photo Upload Title",
        gql: UPDATE_AND_APPROVE_PHOTO_UPLOAD_TITLE,
        errorHandler
    });
};
